import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";
import { ASSETS } from "../i18n/translations";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer data-testid="footer" className="border-t border-[#1d428a]/20 bg-white">
      <div className="px-6 md:px-12 lg:px-20 py-16">
        <div className="grid grid-cols-12 gap-y-10">
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-center gap-4">
              <img src={ASSETS.logo} alt="Schweizer Planmanufaktur GmbH" className="h-14 w-auto" />
              <div className="leading-tight">
                <div className="font-display-mid text-xl text-[#1d428a]">SCHWEIZER</div>
                <div className="font-mono-tech text-[#df4661] mt-0.5">PLANMANUFAKTUR GMBH</div>
              </div>
            </div>
            <p className="mt-6 max-w-md text-[#5A6270] text-sm">{t.footer.tagline}</p>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="font-mono-tech text-[#df4661] mb-4">NAV</div>
            <ul className="space-y-2">
              {["services", "industries", "process", "models", "about", "contact"].map((k) => (
                <li key={k}>
                  <a href={`#${k}`} className="text-[#0A0A0A] hover:text-[#1d428a] transition-colors">
                    {t.nav[k]}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="font-mono-tech text-[#df4661] mb-4">CONTACT</div>
            <ul className="space-y-2 text-[#0A0A0A]">
              <li>{t.contact.info_address}</li>
              <li>
                <a className="link-underline" href={`tel:${t.contact.info_phone.replace(/\s+/g, "")}`}>
                  {t.contact.info_phone}
                </a>
              </li>
              <li>
                <a className="link-underline" href={`mailto:${t.contact.info_email}`}>
                  {t.contact.info_email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[#1d428a]/15 flex flex-col md:flex-row md:items-center md:justify-between gap-4 font-mono-tech text-[#5A6270]">
          <div>© {new Date().getFullYear()} SCHWEIZER PLANMANUFAKTUR GMBH — {t.footer.rights}</div>
          <div className="flex gap-6">
            <Link to="/impressum" data-testid="footer-imprint-link" className="hover:text-[#1d428a]">{t.footer.imprint}</Link>
            <Link to="/datenschutz" data-testid="footer-privacy-link" className="hover:text-[#1d428a]">{t.footer.privacy}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
